// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"bb1336c7","289":"88264bed","455":"a20c54b3","706":"d77bcd03","823":"b6f03f8f","882":"23b36671"}[chunkId] + ".chunk.css";
};